import React from 'react';
import PropTypes from 'prop-types';
import { Plus } from 'lucide-react';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import Image from '@client/components/images/image/Image';
import ButtonLink from '@client/components/designSystem/button/ButtonLink';
import useShellButtonSize from '@client/components/designSystem/useShellButtonSize';
import sparkLogo from '@client/shared/icons/ic-spark.svg';
import { CREATE_CAMPAIGN_TO, DASHBOARD_TO } from './AdminNavigation';
import styles from './adminSidebar.scss';

// The logo and the "Create campaign" call to action at the top of the sidebar.
function SidebarBrand({ onNavigate }) {
  const size = useShellButtonSize();

  return (
    <>
      <ReactLink
        to={DASHBOARD_TO}
        className={styles.logo}
        aria-label="Sparks home"
        onClick={onNavigate}
      >
        <Image
          className={styles.logoImage}
          height="84"
          width="84"
          src={sparkLogo}
          alt=""
        />
      </ReactLink>
      <ButtonLink
        to={CREATE_CAMPAIGN_TO}
        size={size}
        startIcon={<Plus />}
        className={styles.createCampaign}
        onClick={onNavigate}
      >
        Create campaign
      </ButtonLink>
    </>
  );
}

SidebarBrand.propTypes = {
  onNavigate: PropTypes.func,
};

export default SidebarBrand;
